// extracted by css-extract-rspack-plugin
export default {"chirpButtons":"chirpButtons-TQ8u6l","button":"button-yZllRo"};